import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  // Client Management
  {
    q: 'How does Client Management connect with finance modules?',
    a: 'Clients link directly to invoices, income, and expenses so you can view client-wise billing, payments, and revenue analytics without switching tools.',
  },
  {
    q: 'Can I add or edit clients during invoice creation?',
    a: 'Yes. Use the client selector to pick an existing client or add a new one on the fly via a popup without leaving the current flow.',
  },

  // Project Management
  {
    q: 'Do projects support phases and milestone billing?',
    a: 'Yes. Break projects into phases/milestones, attach deliverables, and trigger phase-wise invoices tied to completion.',
  },
  // {
  //   q: 'Can clients see project progress?',
  //   a: 'Clients get clear visibility at every milestone. Documents and status live centrally, reducing back-and-forth and missed updates.',
  // },

  // Invoices & Quotes
  {
    q: 'Are invoices and quotes GST-compliant?',
    a: 'Yes. Quotes and invoices support SGST/CGST/IGST, discounts, totals in words, PDF export, and branded templates.',
  },
  {
    q: 'Can quotes convert into invoices?',
    a: 'Yes. Accepted quotes convert to invoices in one click, keeping a clean lifecycle from quote to cash.',
  },
  {
    q: 'How do reminders and statuses work for invoices?',
    a: 'Invoices track Paid/Unpaid/Overdue with dashboards, while automated reminders nudge clients before or after due dates.',
  },

  // Recurring Invoices
  {
    q: 'Can I automate subscriptions or retainers?',
    a: 'Yes. Set weekly, monthly, or custom schedules with end dates and view parent–child histories for recurring cycles.',
  },

  // Employee Management (Pay slips & HR)
  {
    q: 'What’s included in pay slips?',
    a: 'Structured earnings and deductions, attendance/days summary, net pay in words, and brand/logo in a PDF-ready format.',
  },
  {
    q: 'Do you support HR data like bank and PAN?',
    a: 'Yes. Maintain employee profiles with role, join date, PAN, bank details, and identifiers in one place.',
  },

  // Income & Expenses
  {
    q: 'Can I bulk upload expenses?',
    a: 'Yes. Upload CSVs with validation and error handling to add multiple expenses quickly.',
  },
  {
    q: 'Do you support AI-based receipt scanning?',
    a: 'Planned. Roadmap includes AI receipt parsing, recurring entries, and automatic purchase/sales entries with COGS.',
  },

  // Payments and Currencies (Roadmap)
  {
    q: 'Do you support online payments and multi-currency?',
    a: 'Roadmap includes Razorpay/Stripe for direct payments and multi-currency issuance with exchange rate handling.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="faq-section container">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className={`faq-item ${isOpen ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggle(i)} aria-expanded={isOpen}>
                <span>{item.q}</span>
                <span className={`faq-icon ${isOpen ? 'rotate' : ''}`}>⌄</span>
              </button>
              <div className="faq-answer" style={{ maxHeight: isOpen ? '200px' : '0px' }}>
                <p>{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;
